class RecipientDetailsModel {
    public RecipientName: string;
    public RecipientAddress: string;
    public RecipientPhoneNumber: string;
    public RecipientFaxNumber: string;

    public constructor(fields?: Partial<RecipientDetailsModel>) {
        Object.assign(this, fields);
    }
}

export { RecipientDetailsModel };
